var APIError = require("lib/shared/APIError");
var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")

if ((!window.$wr) || $wr.isDevelopment()) {
	var Client = new WhooosReadingClientApi.Client("localhost:3002", "http");
} else if ($wr.isStaging()) {
	var Client = new WhooosReadingClientApi.Client("api.savvashortondev.com", "https");
} else {
	var Client = new WhooosReadingClientApi.Client("api.whooosreading.org", "https"); // Uses the default endpoint for the library
}

window.NoUseAPIClient = Client;

Client.addResponseHandler((response) => {
	if (response.ok) {
		return response;
	} else {
		console.log(response, "ERROR RESPONSE")
		handleHTTPError(response.status)

		var error = new APIError(
			"WR",
			response.status,
			response.url
		);
		return Promise.reject(error);
	}
})

function handleHTTPError(status) {
	LuckyOrangeClient.tagComponent("HTTPError")
	function displayAlert(title, text) {
		if (window.wrNotifications) {
			window.wrNotifications.triggerDropDownNotification({ title: title,
				text: text, icon: "exclamation-sign", type: "error" }, 6000);

		} else {
			alert(title + ": " + text);
		}
	}

	switch(status) {
	case 401:
		displayAlert("You've been logged out!", "Log in to see the page you were trying to view.");
		$wr.redirect("/login");
		break;

	case 403:
		displayAlert("Sorry!", "You can't view this page");
		$wr.redirect("/");
		break;

	case 404:
		displayAlert("Sorry!", "You can't view this page");
		$wr.redirect("/");
		break;

	case 400:
		displayAlert("Something went wrong, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
		// if (onError) { onError() }
		break;

	case 500:
		// This probably wasn't on a route load because we should have caught that in the route onEnter
		displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
		// if (onError) { onError() }
		break;

	case 502:
	case 503:
		displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... one of our servers seems to have gone down. Please try again later!");
		// if (onError) { onError() }
		break;

	case 504:
		displayAlert("Something went wrong on our end, sorry!", "Too many people are using WR right now! We are working on it now. Please try again later!");
		// if (onError) { onError() }
		break;
	}
}

module.exports = Client;


// WEBPACK FOOTER //
// ./modules/lib/web/APIClient.js